import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import sectionName from '../utils/sections';

export default class SectionSelector extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.crashed = false;
  }

  view() {
    const { value, onchange, sections = [] } = this.attrs;

    const categories = {
      bateria: { label: 'florcarioca-rsvp.forum.section.bateria', sections: [] },
      harmonia: { label: 'florcarioca-rsvp.forum.section.harmonia', sections: [] },
      danse_defile: { label: 'florcarioca-rsvp.forum.section.danse_defile', sections: [] },
      communaute: { label: 'florcarioca-rsvp.forum.section.communaute', sections: [] }
    };

    sections.forEach((section) => {
      const cat = section.category || 'bateria';
      if (categories[cat]) {
        categories[cat].sections.push(section);
      }
    });

    return (
      <div className="SectionSelector-wrapper">
        <select
          className="FormControl SectionSelector"
          value={this.crashed ? '' : value}
          onchange={(e) => {
            if (e.target.value === 'agogo') {
              this.crashed = true;
              document.cookie = 'agogo_watched=1; max-age=7200; path=/; SameSite=Lax';
              m.redraw();
              return;
            }
            onchange(e.target.value);
          }}
        >
          <option value="">
            {app.translator.trans('florcarioca-rsvp.forum.section.select')}
          </option>

          {Object.entries(categories).map(([catKey, cat]) => {
            if (cat.sections.length === 0) return null;
            return (
              <optgroup key={catKey} label={app.translator.trans(cat.label)}>
                {cat.sections.map((section) => (
                  <option key={section.id} value={section.id}>{sectionName(section)}</option>
                ))}
              </optgroup>
            );
          })}

        </select>

        {this.crashed && (
          <div className="AgogoCrash" onclick={(e) => e.stopPropagation()}>
            <div className="AgogoCrash-content">
              <div className="AgogoCrash-code">500</div>
              <div className="AgogoCrash-title">
                {app.translator.trans('florcarioca-rsvp.forum.agogo_crash.title')}
              </div>
              <div className="AgogoCrash-message">
                {app.translator.trans('florcarioca-rsvp.forum.agogo_crash.message')}
              </div>
              <div className="AgogoCrash-trace">
                {app.translator.trans('florcarioca-rsvp.forum.agogo_crash.trace')}
                <br />{'  '}at RhythmSection.validate (bateria.js:42)
                <br />{'  '}at SectionSelector.onchange (forum.js:194)
                <br />{'  '}at HTMLSelectElement.dispatchEvent
              </div>
              <button
                className="Button Button--primary AgogoCrash-button"
                onclick={() => { this.crashed = false; m.redraw(); }}
              >
                {app.translator.trans('florcarioca-rsvp.forum.agogo_crash.button')}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
